import type { DirectoryEditSchemaEditPayload } from '@repo/schemas/directory/directoryEdit';

import { useQueryClient } from '@tanstack/react-query';

import { useBatchMutation } from '#batch-mutations/useBatchMutations';

import { DirectoryService } from './directoryService';
import { DirectoryKey } from './keys';

export function useEditDirectories(directoryId?: string) {
  const queryClient = useQueryClient();

  return useBatchMutation({
    mutationFn: (data: DirectoryEditSchemaEditPayload) => DirectoryService.editDirectory(data).then((response) => response.data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [DirectoryKey.DIRECTORY, directoryId],
      });
    },
  });
}
